import React, { useState, useEffect } from 'react';
import { useSocket } from 'utils/hooks/useSocket';
import { WalletDataProvider } from 'context/WalletDataContext';
import { TradeUpdateProvider } from 'context/TradeUpdateContext';
import { useTournament } from 'context/TournamentContext';
import { BrowserView } from 'react-device-detect';
import FullPageLoad from 'components/ui/FullPageLoad';
import ModalSmallInfo from 'components/ui/ModalSmallInfo';
import GameWrapper from 'components/layout/GameWrapper';
import EndWrapper from 'components/layout/EndWrapper';
import RankingCompact from 'components/game/RankingCompact';
import TournamentBelt from 'components/game/TournamentBelt';
import BottomSection from 'components/game/BottomSection';
import GraphBox from 'components/game/GraphBox';
import OrderPanel from 'components/game/OrderPanel';
import EndPage from 'components/End/EndPage';
import CancelRefundView from 'components/End/CancelRefundView/CancelRefundView';
import FinalizingView from 'components/End/FinalizingView/FinalizingView';
import MobileFlowBottom from 'components/MobileFlowBottom/MobileFlowBottom';
import UserState from 'components/StatusFlow/UserState';
import Footer from 'components/ui/Footer';
import { deriveTournamentPhase } from 'utils/tournamentPhase';

import {
  Wrapper,
  RowTop,
  ColLeft,
  Box,
  ColRight,
  RightStack,
  RightFooterStack,
  AsideBox,
  MobileOrderPanelWrap,
  RwdContent,
} from './styled';

const Game = () => {
  const { socket } = useSocket();
  const { tournamentDetails, tournamentStatus } = useTournament();
  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData;
  const tournamentType = attributes?.trade_type;
  const orderPanelType = tournamentType === 'Margin' ? 'margin' : 'spot';
  const endAt: string | null | undefined = attributes?.end_at ?? attributes?.endDate;
  const phase = deriveTournamentPhase(tournamentStatus, endAt);
  const isTrading = phase === 'TRADING';
  const [isloadPage, setLoadPage] = useState<Promise<boolean | void> | boolean>(true);

  useEffect(() => {
    const timeout = setTimeout(() => setLoadPage(false), 1000)
    return () => clearTimeout(timeout);
  }, [])
  if (isloadPage) {
      return <FullPageLoad/>;
  };

  return (
    <TradeUpdateProvider>
      <GameWrapper>
        {socket?.connected && tournamentDetails && (
          <WalletDataProvider tournamentDetails={tournamentDetails}>
            <Wrapper>
              <RowTop>
                <ColLeft>
                  <Box className={`boxDetails${!isTrading ? ' boxEnd' : ''}`}>
                    {phase === 'FINISHED' &&
                      <EndWrapper>
                        <EndPage tournamentDetails={tournamentDetails} />
                      </EndWrapper>
                    }

                    {phase === 'FINALIZING' &&
                      <EndWrapper>
                        <FinalizingView />
                      </EndWrapper>
                    }

                    {phase === 'CANCELLED' &&
                      <EndWrapper>
                        <CancelRefundView />
                      </EndWrapper>
                    }

                    {isTrading &&
                      <>
                        <RwdContent>
                          <ModalSmallInfo />
                          <GraphBox tournamentDetails={tournamentDetails} />
                        </RwdContent>

                        <MobileOrderPanelWrap>
                          <OrderPanel
                            tournamentDetails={tournamentDetails}
                            type={orderPanelType}
                          />
                        </MobileOrderPanelWrap>
                      </>
                    }
                  </Box>
                  <BottomSection tournamentDetails={tournamentDetails} />
                </ColLeft>
                <ColRight>
                  <BrowserView>
                    <RightStack>
                      {isTrading && (
                        <>
                          <TournamentBelt />
                          <OrderPanel
                            tournamentDetails={tournamentDetails}
                            type={orderPanelType}
                          />
                        </>
                      )}
                      <RankingCompact />
                    </RightStack>
                    <RightFooterStack>
                      <AsideBox>
                        <UserState tournamentDetails={tournamentDetails} />
                      </AsideBox>
                      <AsideBox>
                        <Footer />
                      </AsideBox>
                    </RightFooterStack>
                  </BrowserView>
                </ColRight>
              </RowTop>
            </Wrapper>

            <MobileFlowBottom />

          </WalletDataProvider>
        )}
      </GameWrapper>
    </TradeUpdateProvider>
  );
}
export default Game;
